const REDACTED = '[REDACTED]'

const SENSITIVE_KEY = /^(?:authorization|cookie|cookies|password|pass|secret|token|accessToken|refreshToken|session|email|mail|rut|run|phone|telefono|direccion|address|nombre|name|apellido|username|userId|tenantId|bomberoId|ip|ip_address)$/i
const IDENTIFIER_PATH_SEGMENT = /^(?:\d+|[0-9a-f]{8}-[0-9a-f-]{27,}|[a-z0-9_-]{20,})$/i
const EMAIL_IN_TEXT = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi
const BEARER_IN_TEXT = /Bearer\s+[A-Za-z0-9._~+\/-]+=*/gi

function sanitizeText(value) {
  return value.replace(EMAIL_IN_TEXT, REDACTED).replace(BEARER_IN_TEXT, `Bearer ${REDACTED}`)
}

export function sanitizeSentryUrl(value) {
  if (typeof value !== 'string') return value

  try {
    const absolute = /^[a-z][a-z\d+.-]*:\/\//i.test(value)
    const url = new URL(value, 'https://sentry.invalid')
    url.search = ''
    url.hash = ''
    url.pathname = url.pathname
      .split('/')
      .map((segment) => (IDENTIFIER_PATH_SEGMENT.test(segment) ? ':id' : segment))
      .join('/')

    return absolute ? url.toString().replace(/\/$/, '') : `${url.pathname}${url.search}${url.hash}`
  } catch {
    return sanitizeText(value.split(/[?#]/, 1)[0])
  }
}

function sanitizeValue(value, key, seen) {
  if (SENSITIVE_KEY.test(key)) return REDACTED
  if (typeof value === 'string') return key.toLowerCase() === 'url' ? sanitizeSentryUrl(value) : sanitizeText(value)
  if (value === null || typeof value !== 'object') return value
  if (seen.has(value)) return '[CIRCULAR]'

  seen.add(value)
  if (Array.isArray(value)) return value.map((item) => sanitizeValue(item, '', seen))

  return Object.fromEntries(
    Object.entries(value).map(([nestedKey, nestedValue]) => [
      nestedKey,
      sanitizeValue(nestedValue, nestedKey, seen),
    ]),
  )
}

export function sanitizeSentryEvent(event) {
  if (!event || typeof event !== 'object') return event

  const sanitized = sanitizeValue(event, '', new WeakSet())
  delete sanitized.user

  if (event.request) {
    sanitized.request = {
      ...(event.request.method ? { method: event.request.method } : {}),
      ...(event.request.url ? { url: sanitizeSentryUrl(event.request.url) } : {}),
    }
  }

  return sanitized
}

